export default function SceneHeading ({ children }) {
  return (
    <div className='font-bold uppercase'>
      {children}
    </div>
  )
}
